// frontend/src/components/ContactForm.jsx
import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import "../styles/Contact.css";
import RetroFormLayout from "../components/RetroFormLayout";
import "../styles/Hero.css";
import {
  RetroInput,
  RetroButton,
  RetroTextarea,
  RetroSelect,
  RetroFileInput,
  RetroCheckbox,
  RetroSequenceCheck,
} from "../components/RetroFields";
import { newContact } from "../api/frontApi";

const resetForm = () => {
  return {
    nom: "",
    email: "",
    telephone: "",
    objet: "Informations sur les produits",
    message: "",
    taille: "",
    source: "",
    consentement: false,
  };
};

const RetroContactForm = () => {
  const [errors, setErrors] = useState({});
  const [isAntiBotVerified, setIsAntiBotVerified] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState(resetForm());

  const subjectOptions = [
    {
      value: "Informations sur les produits",
      text: "Informations sur les produits",
    },
    { value: "Demande de devis", text: "Demande de devis" },
    { value: "Collaborations", text: "Collaborations" },
    { value: "Autre", text: "Autre" },
  ];
  const sizeOptions = [
    { value: "S", label: "S" },
    { value: "M", label: "M" },
    { value: "L", label: "L" },
    { value: "XL", label: "XL" },
    { value: "XXL", label: "XXL" },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nom) newErrors.nom = "Le nom est obligatoire";
    if (!formData.email) newErrors.categorie = "L'email est obligatoire";
    if (!formData.message) newErrors.message = "Le message est obligatoire";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [showKonami, setShowKonami] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm() || !formData.consentement) {
      alert("Veuillez accepter le traitement des données.");
      return;
    }

    try {
      const response = await newContact(formData);
      setFormData(resetForm());
      setIsSubmitted(true);
    } catch (error) {
      alert("Erreur lors de l'envoi du formulaire.");
    }
  };

  return (
    <>
    <div style={{ marginBottom : '50px'}}>
      <Navbar></Navbar>
    </div>
      {isSubmitted ? (
        <div className="success-message">
          Votre message a été envoyé avec succès !
        </div>
      ) : (
        <RetroFormLayout title="" onSubmit={handleSubmit}>
          <RetroInput
            label="Nom et Prénom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
            error={errors.nom}
            className={!formData.nom ? "retro-input-empty" : ""}
          />

          <RetroInput
            label="Email*"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
            className={!formData.email ? "retro-input-empty" : ""}
          />

          <RetroInput
            label="Téléphone"
            name="telephone"
            value={formData.telephone}
            onChange={handleChange}
          />

          <RetroSelect
            label="Objet"
            name="objet"
            value={formData.objet}
            onChange={handleChange}
            options={subjectOptions.map((o) => ({
              value: o.value,
              label: o.text,
            }))}
            error={errors.categorie}
          />

          <RetroTextarea
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            error={errors.message}
            className={!formData.message ? "retro-input-empty" : ""}
          />

          <RetroSelect
            label="Taille"
            name="taille"
            value={formData.taille}
            onChange={handleChange}
            options={sizeOptions.map((o) => ({
              value: o.value,
              label: o.label,
            }))}
          />

          <RetroInput
            label="Comment nous avez-vous connus ?"
            name="source"
            value={formData.source}
            onChange={handleChange}
          />

          <RetroCheckbox
            label="J'accepte le traitement des données personnelles*"
            name="consentement"
            checked={formData.consentement}
            onChange={handleChange}
            error={errors.consentement}
            className={!formData.consentement ? "retro-input-empty" : ""}
          />

          <RetroSequenceCheck onSuccess={setIsAntiBotVerified} />

          <RetroButton
            type="submit"
            disabled={
              !isAntiBotVerified ||
              !formData.consentement ||
              !formData.nom ||
              !formData.email ||
              !formData.message ||
              !formData.objet
            }
            className={
              !isAntiBotVerified ||
              !formData.consentement ||
              !formData.nom ||
              !formData.email ||
              !formData.message ||
              !formData.objet
                ? "disabled-style"
                : ""
            }
          >
            Envoyer
          </RetroButton>
        </RetroFormLayout>
      )}
      ;
    </>
  );
};

export default RetroContactForm;
